import { render, staticRenderFns } from "./FormKioskDevice.vue?vue&type=template&id=01b1b69e&"
import script from "./FormKioskDevice.vue?vue&type=script&lang=js&"
export * from "./FormKioskDevice.vue?vue&type=script&lang=js&"
import style0 from "./FormKioskDevice.vue?vue&type=style&index=0&id=01b1b69e&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b1b69e')) {
      api.createRecord('01b1b69e', component.options)
    } else {
      api.reload('01b1b69e', component.options)
    }
    module.hot.accept("./FormKioskDevice.vue?vue&type=template&id=01b1b69e&", function () {
      api.rerender('01b1b69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/kiosk-device/form/FormKioskDevice.vue"
export default component.exports